<base-support-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Отключить'" (onOk)="ok()" >
	<p>
		Номер счёта: <span class="badge badge-info">{{invoiceNumber}}</span>
		<br>
		Тариф: <span class="badge badge-info">{{tariffId.toUpperCase()}}</span>
		<br>
		Действителен до: <span class="badge badge-info">{{dateTo | date:"dd.MM.yyyy"}}</span>
	</p>
</base-support-modal>
